import { Provider } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';

export const COMMON_DIRECTIVES: Provider[] = [NgFor, NgIf];
